import { computeBestProfile } from 'utils/lead/leadUtils';
import {
  LeadSearchFieldProps,
  LeadsSearchResponseItem,
} from './LeadSearchField.types';
import { LeadSearchFieldAsyncTypeahead } from './LeadSearchField.styles';
import useLeadSearchField from './useLeadSearchField';
import LeadSelectOption from './LeadSelectOption';

const LeadSearchField: React.FC<LeadSearchFieldProps> = ({
  align,
  name,
  preFetchedProperties,
  withMessages,
  ...props
}) => {
  const { searchHandler } = useLeadSearchField(
    preFetchedProperties,
    withMessages,
  );

  return (
    // @ts-expect-error TS2769 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
    <LeadSearchFieldAsyncTypeahead
      align={align}
      name={name}
      labelKey={(option: LeadsSearchResponseItem) => computeBestProfile(option)}
      searchHandler={searchHandler}
      renderMenuItemChildren={(option: LeadsSearchResponseItem) => (
        <LeadSelectOption option={option} />
      )}
      {...props}
    />
  );
};

export default LeadSearchField;
